<template>
    <div>
        <!-- contract edit -->
        <d-contract-lim-edit
            v-model      = "edit"
            :type-id     = "contract && contract.type ? contract.type.id : null"
            :contract-id = "contract ? contract.id : null"
            :company-id  = "contract && contract.company ? contract.company.id : null"
            @saved       = "onSaved"
        />
        <!-- contract edit -->

        <c-list-card
            :background = "background"
            :icon       = "icon"
            @edit       = "onEdit"
            @selected   = "onSelected"
        >
            <template v-slot:title>
                <div class="primary--text">
                    {{ contract.id }}
                </div>
                <v-spacer/>
                <div class="pr-1 primary--text" v-if="isLim">
                    <span>{{ money(contract.pricePerMonth) }}</span>
                    <span v-if="contract.lgsPerMonth"> / {{ money(contract.lgsPerMonth) }}</span>
                </div>
                <v-chip
                    v-if        = "showTierChip"
                    x-small
                    :color      = "tierChipColor"
                    :text-color = "tierChipTextColor"
                    class       = "ml-1"
                >
                    {{ contract.tier.name }}
                </v-chip>
                <div class="pr-1 primary--text" v-if="isDls">
                    {{ money(contract.netamount) }}
                </div>
            </template>

            <template v-slot:buttons>
                <a @click.stop="onRenew" v-if="isAutorenew && selected && selected.id === contract.id">
                    <v-icon
                        color = "primary"
                        size  = "20"
                        style = "margin-top: -2px"
                        class = "toolbar-button"
                    >
                        mdi-autorenew
                    </v-icon>
                </a>
            </template>

            <template v-slot:body>
                <!-- Invoice recipient -->
                <div v-if="invoice" class="pt-1" >
                    <div class="v-flex">
                        <div
                            class = "card-subtitle"
                        >
                            {{ invoice.name }}
                        </div>

                        <v-icon
                            color = "primary"
                            size  = "20"
                            class = "recipient-icon"
                        >
                            mdi-alpha-r-box
                        </v-icon>

                        <v-icon
                            v-if  = "invoice.benefit"
                            color = "primary"
                            size  = "20"
                            class = "recipient-icon"
                        >
                            mdi-alpha-l-box
                        </v-icon>
                        <v-spacer />
                    </div>
                    <div class="card-subtitle" v-html="toHtml(invoice.nameAdd)"></div>
                    <div class="card-subtitle-add">{{ invoice.street }}, {{ invoice.zip }} {{ invoice.city }} </div>
                </div>
                <!-- Invoice recipient -->

                <div v-if="benefit && (!invoice || invoice.id !== benefit.id)" class="pt-0">
                    <v-divider class="mt-2 mb-2" />
                    <div class="v-flex">
                        <div class="card-subtitle">{{ benefit.name   }} </div>
                        <v-icon color="primary" size="20" class="recipient-icon">mdi-alpha-l-box</v-icon>
                        <v-spacer />
                    </div>
                    <div class="card-subtitle-add" v-html="toHtml(benefit.nameAdd)"></div>
                    <div class="card-subtitle-add">{{ benefit.street }}, {{ benefit.zip }} {{ benefit.city }} </div>
                </div>
            </template>
        </c-list-card>
    </div>
</template>

<script>

import CListCard         from "@/modules/core/components/utils/CListCard";
import DContractLimEdit  from "@/modules/msd/company/contract/components/controls/lim/DContractLimEdit";
import Contract          from "@/modules/msd/company/contract/service/Contract";
import { shouldDisplayTierChip, tierColor, tierTextColor } from "@/modules/msd/company/contract/service/ContractTier";
import ContractCardMixin from "@/modules/msd/company/contract/components/controls/common/ContractCardMixin";

export default {
    name: "CContractLimCard",

    components: {
        DContractLimEdit,
        CListCard,
    },

    mixins: [
        ContractCardMixin
    ],

    computed: {
        icon () {
            if (!this.contract || !this.contract.type) {
                return {
                    label : null,
                    active: null,
                }
            }

            return {
                label : this.contract.type.id === 1 ? "LM" : "DLS",
                active: this.contract.active,
            }
        },

        isLim () {
            if (!this.contract.type) {
                return false;
            }
            return this.contract.type.id === Contract.enums.types.lim;
        },

        isDls () {
            if (!this.contract.type) {
                return false;
            }
            return this.contract.type.id === Contract.enums.types.dls;
        },

        showTierChip () {
            return shouldDisplayTierChip(this.contract);
        },

        tierChipColor () {
            return tierColor(this.contract);
        },

        tierChipTextColor () {
            return tierTextColor(this.contract);
        },

        invoice () {
            return this.contract.invoiceRecipient;
        },

        benefit () {
            return this.contract.benefitRecipient;
        }
    },
}
</script>

<style scoped>


.card-subtitle {
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100% - 40px);
    overflow: hidden;
}

.card-subtitle-add {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .v-card--link:focus:before {
    opacity: 0.0!important;
}


</style>